import React from 'react';

export default function Media() {
  return (
    <>
      <h2 className="page-title">📺 En Vivo</h2>

      {/* Live Stream */}
      <div className="card">
        <h3 style={{ marginBottom: 8 }}>🔴 Transmisión en Vivo</h3>
        <p style={{ marginBottom: 16, fontSize: '0.9rem', color: 'var(--text-sub)' }}>
          Síguenos en vivo durante nuestros servicios en YouTube.
        </p>
        <a
          href="https://www.youtube.com/@bethesdaespa%C3%B1ol/streams"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: '#cc0000', color: 'white',
            padding: '14px 20px', borderRadius: 12,
            textDecoration: 'none', fontWeight: 700,
            fontSize: '0.95rem',
          }}
        >
          <span style={{ fontSize: '1.4rem' }}>▶️</span>
          YouTube Live — Bethesda Español
        </a>
      </div>

      {/* YouTube */}
      <div className="card">
        <h3 style={{ marginBottom: 8 }}>▶️ YouTube</h3>
        <p style={{ marginBottom: 16, fontSize: '0.9rem', color: 'var(--text-sub)' }}>
          Mira nuestros servicios en vivo y el archivo de sermones anteriores.
        </p>
        <a
          href="https://www.youtube.com/@bethesdaespa%C3%B1ol"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: '#FF0000', color: 'white',
            padding: '14px 20px', borderRadius: 12,
            textDecoration: 'none', fontWeight: 700,
            fontSize: '0.95rem', marginBottom: 12,
          }}
        >
          <span style={{ fontSize: '1.4rem' }}>▶️</span>
          Canal de YouTube — Bethesda Español
        </a>
        <a
          href="https://www.youtube.com/@bethesdaespa%C3%B1ol/streams"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: '#f9f9f9', color: '#FF0000',
            border: '1.5px solid #FF0000',
            padding: '14px 20px', borderRadius: 12,
            textDecoration: 'none', fontWeight: 700,
            fontSize: '0.95rem',
          }}
        >
          <span style={{ fontSize: '1.4rem' }}>📂</span>
          Archivo de Sermones
        </a>
      </div>

      {/* Follow Us */}
      <div className="card">
        <h3 style={{ marginBottom: 8 }}>🤝 Síguenos en Redes</h3>
        <p style={{ marginBottom: 16, fontSize: '0.9rem', color: 'var(--text-sub)' }}>
          Mantente conectado con nuestra comunidad, noticias y momentos especiales.
        </p>
        <div style={{ display: 'flex', gap: 12 }}>
          <a
            href="https://www.facebook.com/bethesdaespanoltx"
            target="_blank"
            rel="noreferrer"
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 8,
              background: '#f0f6ff', border: '1.5px solid #1877F2',
              padding: '18px 12px', borderRadius: 12,
              textDecoration: 'none', color: '#1877F2', fontWeight: 700,
              fontSize: '0.85rem',
            }}
          >
            <span style={{ fontSize: '2rem' }}>📘</span>
            Facebook
          </a>
          <a
            href="https://www.instagram.com/bethesda_espanol/"
            target="_blank"
            rel="noreferrer"
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 8,
              background: '#fff0f5', border: '1.5px solid #dc2743',
              padding: '18px 12px', borderRadius: 12,
              textDecoration: 'none', color: '#dc2743', fontWeight: 700,
              fontSize: '0.85rem',
            }}
          >
            <span style={{ fontSize: '2rem' }}>📸</span>
            Instagram
          </a>
        </div>
      </div>
    </>
  );
}
